'use strict';

var _ = require('lodash');
var ColumnIteratorService = function ColumnIteratorService() {
  function forEachColumn(columns, callback, context) {
    _.forEach(columns, function (item, index) {
      if (callback.call(context, item, index) === false) {
        return false;
      }
      _.forEach(item.items, function (subItem, index) {
        if (callback.call(context, subItem, index, item) === false) {
          return false;
        }
      });
    });
  }
  return {
    forEachColumn: forEachColumn
  };
};
ColumnIteratorService.$inject = [];
module.exports = ColumnIteratorService;